module.exports = __webpack_public_path__ + "static/media/left-arrow-icon.c070d6df.svg";